/*
 * 本地接口，依赖业务自身url
 */
import { Request } from "@cttq/cttq-request";
// require.js中


export function getCipherText(params: any) {
  let serverInstance = new Request({
    headers: {
      "Content-Type": "application/json",
      reqSource: "pc",
    },
    baseURL: params.mappingName || '',
  })
  return serverInstance[params.method || 'post']({
    url: params.url,
    headers: params.headers || {},
    data: params.data || {},
  })
}
